import PropTypes from 'prop-types';
import { MessageDescriptorPropType } from './intl';

export const CswPrimaryActionPropType = PropTypes.shape({
  id: PropTypes.string,
  translation: MessageDescriptorPropType,
  getActionFromFulfillmentPlanId: PropTypes.func,
});

/**
 * @typedef {object} CswPrimaryActionPropType
 * @property {string} id
 * @property {MessageDescriptorPropType} translation
 * @property {Function} getActionFromFulfillmentPlanId
 */
